/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModeCalculTarification } from './ModeCalculTarification';
import {
    ModeCalculTarificationFromJSON,
    ModeCalculTarificationFromJSONTyped,
    ModeCalculTarificationToJSON,
    ModeCalculTarificationToJSONTyped,
} from './ModeCalculTarification';

/**
 * Tarification lue (garantie, frais, taxe, franchise, plafond).
 * @export
 * @interface TarifDto
 */
export interface TarifDto {
    /**
     * 
     * @type {string}
     * @memberof TarifDto
     */
    id?: string;
    /**
     * 
     * @type {ModeCalculTarification}
     * @memberof TarifDto
     */
    modeCalcul?: ModeCalculTarification;
    /**
     * 
     * @type {number}
     * @memberof TarifDto
     */
    montantFixe?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TarifDto
     */
    montantFixeHT?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TarifDto
     */
    taux?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TarifDto
     */
    expression?: string | null;
}



/**
 * Check if a given object implements the TarifDto interface.
 */
export function instanceOfTarifDto(value: object): value is TarifDto {
    return true;
}

export function TarifDtoFromJSON(json: any): TarifDto {
    return TarifDtoFromJSONTyped(json, false);
}

export function TarifDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TarifDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'modeCalcul': json['modeCalcul'] == null ? undefined : ModeCalculTarificationFromJSON(json['modeCalcul']),
        'montantFixe': json['montantFixe'] == null ? undefined : json['montantFixe'],
        'montantFixeHT': json['montantFixeHT'] == null ? undefined : json['montantFixeHT'],
        'taux': json['taux'] == null ? undefined : json['taux'],
        'expression': json['expression'] == null ? undefined : json['expression'],
    };
}

export function TarifDtoToJSON(json: any): TarifDto {
    return TarifDtoToJSONTyped(json, false);
}

export function TarifDtoToJSONTyped(value?: TarifDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'modeCalcul': ModeCalculTarificationToJSON(value['modeCalcul']),
        'montantFixe': value['montantFixe'],
        'montantFixeHT': value['montantFixeHT'],
        'taux': value['taux'],
        'expression': value['expression'],
    };
}

